import { createComponent } from "../utils";
import verb from "verb-nurbs-web";

export default createComponent({
  name: "Loft",
  group: "Surface",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 451 211"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M441.76 15.6601L377.045 3.92209C376.436 3.81271 375.826 3.75803 375.217 3.75803C373.686 3.75803 372.162 4.1057 370.776 4.76974C336.811 21.1137 314.69 58.0977 295.174 90.7307L291.955 96.1057C290.178 99.0666 288.181 102.621 286.068 106.387C280.099 117.016 271.298 132.688 261.306 144.571C255.49 133.782 250.599 122.091 245.81 110.567C243.044 103.918 240.185 97.0507 237.22 90.5587C226.13 66.3127 205.529 21.3087 170.646 14.3207C170.56 14.3012 170.494 14.2582 170.416 14.2465L110.916 1.6055C107.549 0.808629 103.849 0.378906 100.15 0.378906C91.806 0.378906 83.1338 2.55082 74.3998 6.84772C27.2708 29.9607 5.0248 112.598 0.290802 176.338C-0.0451377 180.873 2.658 185.096 6.9158 186.693L69.3608 210.013C70.521 210.439 71.7319 210.657 72.9428 210.657C74.8998 210.657 76.849 210.095 78.5366 208.993C81.2593 207.216 82.978 204.259 83.1694 201.009C84.06 185.689 87.5561 145.763 100.794 105.892C110.033 78.0678 121.782 57.6068 135.181 45.6768C143.338 57.6338 150.122 71.9658 155.849 84.0558C158.588 89.8331 161.119 95.6337 163.803 101.783C174.647 126.623 185.858 152.314 208.049 170.693C212.927 174.744 218.013 177.712 223.154 179.525C223.169 179.533 286.685 199.556 286.685 199.556H286.704L286.798 199.587C286.821 199.591 286.841 199.591 286.864 199.595C290.649 200.86 294.513 201.509 298.376 201.509C329.821 201.509 351.79 160.474 366.329 133.329C368.63 129.02 370.618 125.302 372.357 122.306L375.552 116.775C393.99 84.8447 414.884 48.6497 444.251 35.0047C448.294 33.1258 450.665 28.8485 450.091 24.4187C449.516 20.0007 446.141 16.4539 441.759 15.657L441.76 15.6601ZM141.66 28.7931C114.496 42.5981 101.168 73.1171 91.8361 100.469C80.8631 132.61 74.8951 166.559 72.9451 200.426L10.5001 177.102C14.5079 123.172 33.7231 38.1921 78.9021 16.0321C80.5505 15.2235 82.1599 14.5438 83.7498 13.9227C84.0896 13.7899 84.4373 13.6766 84.7732 13.5516C86.1482 13.0477 87.4959 12.6141 88.8318 12.2508C89.0036 12.2039 89.1677 12.157 89.3357 12.1102C96.3396 10.2664 102.809 10.2118 108.766 11.618L168.27 24.259C160.188 22.7278 151.325 23.8762 141.661 28.7942L141.66 28.7931ZM363.49 117.176C354.349 132.946 338.99 166.793 319.295 182.672C314.553 186.445 309.131 189.231 302.963 189.473C293.807 189.821 286.951 183.137 281.615 176.547C275.92 169.527 271.388 161.711 266.763 153.965L266.755 153.961C266.755 153.957 266.763 153.957 266.763 153.953C281.572 137.566 293.259 113.816 300.732 101.367C320.619 68.2462 342.24 29.8512 375.216 13.9802L439.927 25.7182C405.853 41.5582 383.763 82.1982 363.489 117.175L363.49 117.176Z"
        fill="currentColor"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "curveOne",
      name: "Curve",
      type: "Curve",
    },
    {
      id: "curveTwo",
      name: "Curve",
      type: "Curve",
    },
  ],
  outputs: [
    {
      id: "result",
      name: "Result",
      type: "Surface",
      compute: ({ curveOne, curveTwo }) => {
        if (curveOne && curveTwo) {
          return new window.rhino.NurbsSurface.createRuledSurface(
            curveOne,
            curveTwo
          );
        }
      },
    },
  ],
});
